export default __webpack_public_path__ + "static/media/header_profile.00b4c102.jpg";